import React from 'react';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';
import { chibidashContent } from '../rich-content/chibidash-complete-content';

const ChibiDashDetailPage = () => {
  return <AutomaticPageBuilder content={chibidashContent} />;
};

export default ChibiDashDetailPage;